import { cva } from 'class-variance-authority';

import styles from './CardSection.module.css';
import { forwardRef } from 'react';

const cardSection = cva(styles.cardSection, {
  variants: {
    isReversed: {
      true: styles.isReversed,
    },
  },
  defaultVariants: {},
});

export interface CardSectionProps {
  /**
   * Decides whether the card section should be reversed
   * @default false
   */
  isReversed?: boolean;

  /**
   * The content of the card section
   */
  children: React.ReactNode;
}

interface CardSectionComponent
  extends React.ForwardRefExoticComponent<
    CardSectionProps & React.RefAttributes<HTMLElement>
  > {
  Content: typeof Content;
  Media: typeof Media;
}

const CardSection = forwardRef<HTMLElement, CardSectionProps>(
  ({ isReversed = false, children }, ref) => (
    <section
      ref={ref}
      className={cardSection({ isReversed })}
      data-testid="card-section"
    >
      <div className={styles.cardContainer}>
        <div className={styles.cardGrid}>{children}</div>
      </div>
    </section>
  ),
) as CardSectionComponent;
CardSection.displayName = 'CardSection';

const Content = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.contentCell}>
    <article className={styles.contentBox}>{children}</article>
  </div>
);
Content.displayName = 'CardSection.Content';

const Media = ({ children }: { children: React.ReactNode }) => (
  <figure className={styles.mediaCell}>{children}</figure>
);
Media.displayName = 'CardSection.Media';

// Attach subcomponents to CardSection
CardSection.Content = Content;
CardSection.Media = Media;

export default CardSection;
